var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"condition-content"},[_c('compare-value',{ref:"compare",attrs:{"input-placeholder":"请输入文本型值","input-unit":"","selector-type":"LOGIC","valid":_vm.valid,"value":_vm.currentValue},on:{"change":_vm.onChange}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }